import { generateUtilityClass, generateUtilityClasses } from '@mui/material'

export interface DateRangePickerDayClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to the root element if `isHighlighting=true` and `outsideCurrentMonth=false`. */
  rangeIntervalDayHighlight: string
  /** Styles applied to the root element if `isStartOfHighlighting=true` or `day` is the start of the month. */
  rangeIntervalDayHighlightStart: string
  /** Styles applied to the root element if `isEndOfHighlighting=true` or `day` is the end of the month. */
  rangeIntervalDayHighlightEnd: string
  /** Styles applied to the preview element. */
  rangeIntervalPreview: string
  /** Styles applied to the root element if `isPreviewing=true` and `outsideCurrentMonth=false`. */
  rangeIntervalDayPreview: string
  /** Styles applied to the root element if `isStartOfPreviewing=true` or `day` is the start of the month. */
  rangeIntervalDayPreviewStart: string
  /** Styles applied to the root element if `isEndOfPreviewing=true` or `day` is the end of the month. */
  rangeIntervalDayPreviewEnd: string
  /** Styles applied to the day element. */
  day: string
  /** Styles applied to the day element if `isHighlighting=false`. */
  dayOutsideRangeInterval: string
  /** Styles applied to the day element if `selected=false` and `isHighlighting=true`. */
  dayInsideRangeInterval: string
  /** Styles applied to the day element if `selected=false`. */
  notSelectedDate: string
}

export type DateRangePickerDayClassKey = keyof DateRangePickerDayClasses

export function getDateRangePickerDayUtilityClass(slot: string) {
  return generateUtilityClass('MuiDateRangePickerDay', slot)
}

export const dateRangePickerDayClasses: DateRangePickerDayClasses = generateUtilityClasses(
  'MuiDateRangePickerDay',
  [
    'root',
    'rangeIntervalDayHighlight',
    'rangeIntervalDayHighlightStart',
    'rangeIntervalDayHighlightEnd',
    'rangeIntervalPreview',
    'rangeIntervalDayPreview',
    'rangeIntervalDayPreviewStart',
    'rangeIntervalDayPreviewEnd',
    'day',
    'dayOutsideRangeInterval',
    'dayInsideRangeInterval',
    'notSelectedDate',
  ],
)
